import getConfig from "next/config";

import { apiRequest } from "@/utils/common/serviceApiHelper/serviceApiUtils";

import {
  type RequestNewsRoomDetailsInterface,
  ResponseNewsRoomDetails,
} from "./newsRoomServiceInterfaces/getNewsRoomDetailsInterface";
import type { RequestNewsRoomInterface } from "./newsRoomServiceInterfaces/getNewsRoomInterface";
import { ResponseNewsRoom } from "./newsRoomServiceInterfaces/getNewsRoomInterface";
import type { RequestNewsRoomRecommendInterface } from "./newsRoomServiceInterfaces/getNewsRoomRecommendInterface";
import { ResponseNewsRoomRecommend } from "./newsRoomServiceInterfaces/getNewsRoomRecommendInterface";

const config =
  typeof window === "undefined"
    ? getConfig()?.serverRuntimeConfig
    : getConfig()?.publicRuntimeConfig;
const cachesNewsTime = config?.publicRuntimeConfig?.cachesNewsTime || 1800;

class NewsRoomServiceApi {
  private baseUrl: string;

  private basePath: string;

  private basePathV2: string;

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl;

    this.basePath = "news-room";

    this.basePathV2 = "v2/news-room";
  }

  async getNewsRoomList(
    params: RequestNewsRoomInterface,
  ): Promise<ResponseNewsRoom> {
    const queryParams = new URLSearchParams(params as any);
    const revalidate = cachesNewsTime;
    try {
      const response = (await apiRequest(
        this.baseUrl,
        `${this.basePathV2}/news?${queryParams}`,
        "GET",
        {},
        false,
        undefined,
        true,
        revalidate,
      )) as any;
      return new ResponseNewsRoom(response);
    } catch (error) {
      return {} as ResponseNewsRoom;
    }
  }

  async getNewsRoomRecommend(
    params: RequestNewsRoomRecommendInterface,
  ): Promise<ResponseNewsRoomRecommend> {
    const queryParams = new URLSearchParams(params as any);
    const revalidate = cachesNewsTime;

    try {
      const response = (await apiRequest(
        this.baseUrl,
        `${this.basePathV2}/recommend?${queryParams}`,
        "GET",
        {},
        false,
        undefined,
        true,
        revalidate,
      )) as any;
      return new ResponseNewsRoomRecommend(response);
    } catch (error) {
      return {} as ResponseNewsRoomRecommend;
    }
  }

  async getNewsRoomDetails(
    params: RequestNewsRoomDetailsInterface,
  ): Promise<ResponseNewsRoomDetails> {
    const queryParams = new URLSearchParams(params as any);
    const revalidate = cachesNewsTime;
    const response = (await apiRequest(
      this.baseUrl,
      `${this.basePathV2}/newsDetails?${queryParams}`,
      "GET",
      {},
      false,
      undefined,
      false,
      revalidate,
    )) as any;
    return new ResponseNewsRoomDetails(response);
  }
}

export default NewsRoomServiceApi;
